"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ShieldCheck, CalendarCheck, MapPin } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SecureYourVisit() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="133753" id="ready-to-begin-your-recovery" className="dark bg-background text-foreground relative py-24 px-6 overflow-hidden flex flex-col items-center justify-center min-h-[60vh] bg-gradient-to-b from-chart-2/5 to-background">
      {}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-chart-2/10 rounded-full blur-[120px] opacity-40" />
      </div>

      <div ref={ref} className={`relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-sans font-bold tracking-tight text-foreground mb-8 leading-tight">
          Ready to Begin Your Recovery?
        </h2>

        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto justify-center mb-16">
          <Button asChild size="lg" className="h-14 px-8 text-base rounded-full bg-primary text-primary-foreground hover:scale-[1.02] transition-transform duration-300">
            <Link to="/ConnectPage">
              <CalendarCheck className="mr-2 size-5" />
              Request a Callback
            </Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="h-14 px-8 text-base rounded-full border-border/50 hover:bg-accent/10 hover:scale-[1.02] transition-transform duration-300 text-foreground">
            <Link to="/YourJourneyPage">
              <MapPin className="mr-2 size-5" />
              Explore Our Care
            </Link>
          </Button>
        </div>

        <div className="flex flex-col items-center gap-6 pt-8 border-t border-border/30 w-full max-w-md">
          <div className="flex items-center gap-2 text-muted-foreground">
            <ShieldCheck className="size-4 text-chart-2" />
            <span className="text-sm uppercase tracking-widest font-medium">
              Patient-Centered Excellence
            </span>
          </div>
          
          <div className="flex items-center justify-center gap-8 opacity-70 grayscale brightness-200 contrast-200 hover:opacity-100 transition-opacity duration-300">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603830/img/bkash_logo_white.png" alt="bKash" className="h-8 w-auto object-contain" />
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603830/img/nagad_logo_white.png" alt="Nagad" className="h-8 w-auto object-contain" />
          </div>
        </div>
      </div>
    </section>;
}